import fetch from './communityFetch';

// 资讯类型
const getNewsCategory = params => fetch({ url: '/news_category', params });
const addNewsCategory = ({ params }) => fetch({ url: '/news_category', methold: 'post', params });

const updateNewsCategory = ({ news_category_id, params, methold }) =>
  fetch({ url: `/news_category/${news_category_id}`, methold, params });

const batchActivateNewsCategory = params => fetch({ url: '/batch_activate_news_category', methold: 'PATCH', params });

const batchDeactivateNewsCategory = params =>
  fetch({ url: '/batch_deactivate_news_category', methold: 'PATCH', params });

// 资讯内容
const getNewsContent = params => fetch({ url: '/news_content', params });
const addNewsContent = ({ params }) => fetch({ url: '/news_content', methold: 'post', params });

const updateNewsContent = ({ news_content_id, params, methold }) =>
  fetch({ url: `/news_content/${news_content_id}`, methold, params });

const batchActivateNewsContent = params => fetch({ url: '/batch_activate_news_content', methold: 'PATCH', params });

const batchDeactivateNewsContent = params => fetch({ url: '/batch_deactivate_news_content', methold: 'PATCH', params });

const newsCategorySearch = () => fetch({ url: '/news_category_label_list' });

const activateStatus = () => fetch({ url: '/activate_status_label_list' });

export default {
  activateStatus,
  newsCategorySearch,
  batchActivateNewsCategory,
  batchDeactivateNewsCategory,
  getNewsCategory,
  addNewsCategory,
  updateNewsCategory,

  batchActivateNewsContent,
  batchDeactivateNewsContent,
  getNewsContent,
  addNewsContent,
  updateNewsContent
};
